import { render } from "./RouteColors.vue?vue&type=template&id=5d77bd62&ts=true"
import script from "./RouteColors.vue?vue&type=script&lang=ts"
export * from "./RouteColors.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__